import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Card, CardBody, CardTitle, Row, Col, Input, Button, Label } from "reactstrap"
import { DetalleParametrosPresupuesto, DetalleParametrosProyeccionHE } from '../TypesParametrosHorasExtras'
import Cargando from 'components/Varios/Cargando'
import { ActualizarParametrosPresupuestoHE, ConsultarDetallePresupuestoAnual, CrearParametrosPresupuestoAnual } from '../FunctionsParametrosHE'
import { showAlert } from '../Actividades/ActividadesHorasExtras'
import NumberFormat from 'react-number-format'
import DatePickerBlueColor from 'components/Varios/DatePicker/DatePickerBlueColor'
import { isWeekday } from 'functions/CalendarFunctions'
// import DecimalInput from 'components/Varios/Inputs/DecimalInput'


type PropsPresupuestoAnualHE = {
    detalle: DetalleParametrosPresupuesto | null | undefined,
    anioParametros: number | undefined,
    parametrosProyeccion:DetalleParametrosProyeccionHE | null | undefined
}


export default function CardPresupuestoAnualHE(props: PropsPresupuestoAnualHE) {

    const [detalleParametros, setdetalleParametros] = useState<DetalleParametrosPresupuesto | null | undefined>(null)
    const [valorPresupuesto, setvalorPresupuesto] = useState<number | null | undefined>(null)
    const [actualizarPresupuesto, setactualizarPresupuesto] = useState<boolean>(false)
    const [crearParametro, setcrearParametro] = useState<boolean>(false)
    const [mensajeErrorValor, setmensajeErrorValor] = useState<string>("")

    const [fechaDesde, setfechaDesde] = useState<string | null>(props.detalle ? props.detalle.fechaDesde : null)
    const [fechaHasta, setfechaHasta] = useState<string | null>(props.detalle ? props.detalle.fechaHasta : null)


    const disabled: boolean = valorPresupuesto === null || valorPresupuesto === undefined
    const disabledGeneral: boolean = false




    useEffect(() => {
        if (detalleParametros?.valor) {

            setvalorPresupuesto(detalleParametros.valor);
        }
    }, [detalleParametros?.valor])

    useEffect(() => {
        if (props.detalle) {
            setdetalleParametros(props.detalle)
        }
    }, [props.detalle])


    useEffect(() => {
        if (valorPresupuesto) {

            const regex = new RegExp("^\\d{1,8}(\\.\\d{0,2})?$");
            if (!regex.test(valorPresupuesto.toString())) {
                setmensajeErrorValor("El valor deber ser máximo 8 valores enteros y 2 decimales");
            }
            else {
                setmensajeErrorValor("");
            }
        }
    }, [valorPresupuesto])



    async function ConsultarDetalle(anio: number) {
        const detalleParametros = await ConsultarDetallePresupuestoAnual(anio);
        if (detalleParametros.status === 200 && detalleParametros.dataResponse) {
            setdetalleParametros(detalleParametros.dataResponse)
        }
        else if (detalleParametros.status === 204) {
            setdetalleParametros(null)
        }
        else {
            const mensajeDefault = "Ha ocurrido un inconveniente al consultar detalle de parámetros de proyección"
            showAlert(detalleParametros.errorMessage ?? mensajeDefault, false)
        }
    }

    async function ActualizarParametroPresupuesto(valor: number | null | undefined, fechaDesde:string| null,fechaHasta:string| null) {
        
        setactualizarPresupuesto(true)

        if (props.detalle && valor && fechaDesde && fechaHasta) {
            const detalle: DetalleParametrosPresupuesto = { ...props.detalle, valor,fechaDesde,fechaHasta };
            const respuesta = await ActualizarParametrosPresupuestoHE(detalle)

            if (respuesta.status === 200) {
                showAlert("Se han actualizado los parámetros sin novedad", true)
                await ConsultarDetalle(props.detalle.anio);
            }
            else {
                const mensajeDefault = "Ha ocurrido un inconveniente al intentar actualizar los parámetros"
                showAlert(respuesta.errorMessage ?? mensajeDefault, false)
            }
        }
        else if (!valor) {
            showAlert("El valor indicado no es válido", false)
        }


        setactualizarPresupuesto(false)
    }

    async function CrearParametros(valor: number | null | undefined, anio: number | undefined,fechaDesde:string|null,fechaHasta:string|null) {

        if (valor && anio && anio > 0 && fechaDesde && fechaHasta) {
            setcrearParametro(true)


            const nuevoParametro: DetalleParametrosPresupuesto = {
                anio: anio,
                valor,
                fechaRegistro: new Date().toISOString(),
                fechaDesde,
                fechaHasta
            }



            const respuesta = await CrearParametrosPresupuestoAnual(nuevoParametro);
            if (respuesta.status === 200 || respuesta.status === 204) {
                showAlert("Se han agregado/actualizado los parámetros sin novedad", true)

            }
            else {
                const mensajeDefault = "Ha ocurrido un evento inesperado. Intente más tarde."
                showAlert(respuesta.errorMessage ?? mensajeDefault, false)

            }

            setcrearParametro(false)
            ConsultarDetalle(anio);
        }
        else {
            showAlert("Debe indicar el valor del presupuesto y sus fechas de vigencia para guardarlo", false)
        }
    }

    function onChangeValue(values) {
        const { formattedValue, value } = values;


        const normalizedValue: number = +value

        if (normalizedValue === 0) {
            showAlert("El valor debe ser mayor a 0", false)
        }

        setvalorPresupuesto(normalizedValue);




        // if (unformattedValue) {
        //     unformattedValue = +unformattedValue;
        // }
        // setvalorPresupuesto(unformattedValue)
    }

    const PickerDesde = useMemo(
        () => {

            const anioUsar = props.anioParametros??new Date().getFullYear();

            const minDate = new Date(anioUsar,0,1,0,0,0);
            const maxDate = new Date(anioUsar,11,31,0,0,0,0)

            return (
                <DatePickerBlueColor
                    value={fechaDesde}
                    //disabled={disabledFinAsignarPresupuesto}
                    name="fechadesdepresupuesto"
                    id="fechahastapresupuesto"
                    onChange={(e) => { setfechaDesde(e) }}
                    min={minDate}
                    max={maxDate}
                    filter={(date: Date) => isWeekday(date)}
                    monthdropdown={true}
                    showYearDropdown={false}

                />
            )

        },
        [fechaDesde],
    )

    const PickerHasta = useMemo(
        () => {

            const anioUsar = props.anioParametros??new Date().getFullYear();

            const minDate = fechaDesde??new Date(anioUsar,0,1,0,0,0);
            const maxDate = new Date(anioUsar,11,31,0,0,0,0)

            return (
                <DatePickerBlueColor
                    value={fechaHasta}
                    //disabled={disabledFinAsignarPresupuesto}
                    name="fechadesdepresupuesto"
                    id="fechahastapresupuesto"
                    onChange={(e) => { setfechaHasta(e) }}
                    min={minDate}
                    max={maxDate}
                    filter={(date: Date) => isWeekday(date)}
                    monthdropdown={true}
                    showYearDropdown={false}

                />
            )

        },
        [fechaDesde,fechaHasta],
    )

    var bloqueoFechasPeriodo = false;
    // if(!props.parametrosProyeccion){
    //     bloqueoFechasPeriodo = true
    // } 
    // else {
    //     const fechaInicioAsig = new Date(props.parametrosProyeccion.fechainicioasigpresupGPE)
    //     const fechaFinAsig = new Date(props.parametrosProyeccion.fechainicioasigpresupGPE)
    //     const fechaActual = new Date()
    //     if(fechaActual.getTime() > fechaFinAsig.getTime()){
    //         bloqueoFechasPeriodo = true
    //     }
        

    // }


    if (actualizarPresupuesto || crearParametro) {
        return <Cargando mensaje='Actualizando presupuesto' />
    }

    return (
        <Card className="cardParametrosHE">
            <CardTitle className="cardHeaderParametrosPresupuesto">
                <span className='pl-3'>
                    Presupuesto para horas extras
                    <span className='pl-3'>
                        <i
                            className="fas fa-info-circle"

                        />
                    </span>

                </span></CardTitle>
            <CardBody className="cardBodyParametrosHE">
                <React.Fragment>
                    <Row className='row-container-bodyParamHE'>
                        <Col xl={12}>
                            <Row>
                                <Col xl={12}>
                                    <span className={"labelParametrosHE"}>Valor anual del presupuesto asignado para Horas Extras</span>


                                </Col>
                            </Row>
                            <Row className={"mt-2"}>
                                <Col xl={4}>
                                    <Row>
                                        <Col xl={12}>
                                            <Label>
                                                Fecha desde
                                            </Label>
                                        </Col>
                                        <Col xl={12}>
                                            {PickerDesde}
                                            {/* <Input readOnly disabled value={""} /> */}

                                        </Col>
                                    </Row>
                                </Col>
                                <Col xl={4}>
                                    <Row>
                                        <Col xl={12}>
                                            <Label>
                                                Fecha hasta
                                            </Label>
                                        </Col>
                                        <Col xl={12}>
                                            {PickerHasta}
                                            {/* <Input readOnly disabled value={""} /> */}
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xl={4}>
                                    <Row>
                                        <Col xl={12}>
                                            <Label>
                                                Presupuesto Anual
                                            </Label>
                                        </Col>
                                        <Col xl={12}>

                                            <NumberFormat
                                                className='form-control'
                                                value={valorPresupuesto}
                                                thousandSeparator={true}
                                                decimalSeparator='.'
                                                fixedDecimalScale={true}
                                                decimalScale={2}
                                                allowNegative={false}
                                                allowEmptyFormatting={true}
                                                placeholder='Ingrese un valor'
                                                onValueChange={onChangeValue}
                                                prefix='$'
                                            />
                                            {/* <DecimalInput
                                                disabledGeneral={disabledGeneral}
                                                onChangeValue={() => console.log("")}
                                                valorPresupuesto={0}

                                            
                                            
                                            /> */}
                                            {/* <Input
                                                value={!valorPresupuesto ? "" : valorPresupuesto}
                                                onChange={(e) => { onChangeValue(e) }}
                                                type="number"
                                                disabled={disabledGeneral}
                                                step="0.01"
                                            /> */}
                                            <small className="small-error">{mensajeErrorValor}</small>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className="justify-content-center">
                                <Col xl={12} className="col-center">

                                    {
                                        detalleParametros?.valoresConsultados ?
                                            <Button
                                                onClick={() => ActualizarParametroPresupuesto(valorPresupuesto,fechaDesde,fechaHasta)}
                                                color="secondary"
                                                disabled={bloqueoFechasPeriodo || actualizarPresupuesto || (!valorPresupuesto || valorPresupuesto <= 0) || mensajeErrorValor !== ""}
                                            >
                                                Guardar
                                            </Button>
                                            :
                                            <Button
                                                onClick={() => CrearParametros(valorPresupuesto, props.anioParametros,fechaDesde,fechaHasta)}
                                                color="secondary"
                                                disabled={crearParametro || (!valorPresupuesto || valorPresupuesto <= 0) || mensajeErrorValor !== ""}
                                            >
                                                Crear
                                            </Button>
                                    }

                                </Col>
                            </Row>
                        </Col>
                    </Row>


                </React.Fragment>
            </CardBody>
        </Card>
    )
}
